
import { Button } from "@/components/ui/button";
import { Layers } from "lucide-react";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuLabel, 
  DropdownMenuSeparator, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { DisplayLayerInfo } from "@/components/layers/types";
import { LayerPanel } from "@/components/layers/LayerPanel";
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface LayerManagementMenuProps {
  layers: DisplayLayerInfo[];
  onToggleVisibility: (layerId: string) => void;
  onRename: (layerId: string, newName: string) => void;
  onBringForward: (layerId: string) => void;
  onSendBackward: (layerId: string) => void;
  triggerContent?: ReactNode;
  className?: string;
}

export const LayerManagementMenu = ({
  layers,
  onToggleVisibility,
  onRename,
  onBringForward,
  onSendBackward,
  triggerContent,
  className
}: LayerManagementMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {triggerContent ? (
          <div className={cn("cursor-pointer", className)}>{triggerContent}</div>
        ) : (
          <Button
            variant="ghost"
            className={cn("h-10 w-10 p-0 text-gray-700 hover:bg-gray-100/80 rounded-lg", className)}
            title="Layer management"
          >
            <Layers className="h-5 w-5" />
          </Button>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="center"
        className="min-w-[280px] p-2 bg-white"
      >
        <DropdownMenuLabel className="text-xs font-medium text-muted-foreground mb-1">
          Layers
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        <div className="max-h-[300px] overflow-y-auto py-1">
          <LayerPanel
            layers={layers}
            onToggleVisibility={onToggleVisibility}
            onRename={onRename}
            onBringForward={onBringForward}
            onSendBackward={onSendBackward}
            compact
          />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
